import { IconWrapper } from '../runtime';
export default IconWrapper('title-view', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 1.99976H14.5M2 13.9998H14.5M10 7.99976H14.5M2.3 9.99976H5.7C5.86569 9.99976 6 9.86544 6 9.69976V6.29976C6 6.13407 5.86569 5.99976 5.7 5.99976H2.3C2.13431 5.99976 2 6.13407 2 6.29976V9.69976C2 9.86544 2.13431 9.99976 2.3 9.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});